<template>
  <div class="chatWr1 px-1">
    <div class="title custom-title">Feedback/Chat</div>
  <b-card class=" b-card-bg">
      <b-card-text>
        <div class="chat-app-window border-top bg-white">
          <div class="active-chat">
            <validation-observer ref="chatRules">
              <!-- style="max-height: 500px; overflow: auto" -->
              <vue-perfect-scrollbar
                ref="scrollToMe"
                :settings="{
                  maxScrollbarLength: 20,
                  scrollBottom: 0,
                  suppressScrollX: true,
                }"
                style="height: 30vh"
                class="scrollable-container scroll-area"
              >
                <div
                  class="chats p-1 h-100"
                  v-if="chats != null"
                >
                  <div
                    v-for="(msgGrp, index) in chats"
                    :key="msgGrp.sender + String(index)"
                    class="chat"
                    :class="
                      userData.username == msgGrp.sender ? '' : 'chat-left'
                    "
                  >
                    <div class="chat-avatar">
                      <b-avatar
                        size="36"
                        class="avatar-border-2 box-shadow-1 bg-custom"
                        variant="transparent"
                        :src="
                          msgGrp.role === 'customers'
                            ? require('@/assets/images/avatars/customers.svg')
                            : require('@/assets/images/avatars/wr1.svg')
                        "
                      />
                    </div>
                    <div class="chat-body m-0">
                      <small
                        :class="
                          userData.username == msgGrp.sender
                            ? 'float-right mr-2'
                            : 'float-left ml-2'
                        "
                        class="d-block"
                      >
                        {{ msgGrp.fullName ? msgGrp.fullName : msgGrp.sender }}
                      </small>

                      <div class="chat-content">
                        <p>{{ msgGrp.message }}</p>
                        <small
                          :class="
                            userData.username == msgGrp.sender
                              ? 'text-white font-weight-bold'
                              : 'text-secondary font-weight-bold '
                          "
                          >[{{ msgGrp.date | formatDate }}]
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </vue-perfect-scrollbar>
              <validation-provider
                name="Message"
                #default="{ errors }"
                rules="required"
              >
                <div class="flex pt-1" style="height: auto !important">
                  <b-input-group
                    class="custom-height-form-chat mr-1"
                  >
                    <input
                      class="custom_height_form_chat"
                      v-model="message"
                      placeholder="Please type your feedback"
                      @keyup.enter="sendChat"
                    />
                  </b-input-group>
                  <div @click="sendChat" class="flex items-center pointer" >
                    <b-img width="30px" :src="iconSend" alt="logo" />
                  </div>
                  <!-- <b-button variant="primary" @click="sendChat">Send</b-button> -->
                </div>
              </validation-provider>
            </validation-observer>
          </div>
        </div>
      </b-card-text>
    
  </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  props: ["request_quotation", "isCustomer"],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      iconSend: require("@/assets/images/icons/icon-send.png"),
      chats: null,
      message: "",
      userData: JSON.parse(localStorage.getItem("userData")),
    };
  },
  mounted() {
    this.loadChart();
  },

  methods: {
    loadChart() {
      if (this.request_quotation != null && this.request_quotation.id != null) {
        useJwt
          .get("wr1?objectType=Chats", {
            params: { search: { id: this.request_quotation.id } },
          })
          .then((response) => {
            this.chats =
              response.data.result == null
                ? null
                : response.data.result.reverse();
          });
      }
    },
    async sendChat(bvModalEvt) {
      bvModalEvt.preventDefault();
      var validate = await this.$refs.chatRules.validate().then((success) => {
        return success;
      });
      if (!validate) {
        return;
      }
      useJwt
        .put("wr1?objectType=SendChat", {
          id: this.request_quotation.id,
          message : this.message,
          date: new Date(),
          role: this.isCustomer ? "customers" : "wr1",
          fullName: this.userData.fullName,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Sent chat to WR1!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.loadChart();
          this.$refs.chatRules.reset();
          this.message = "";
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Send chat error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/customs/request-quotation.scss";
@import "@core/scss/customs/inputV2.scss";
.chatWr1{
  
  
  width: 100% !important;
  .pointer{
    cursor: pointer;
  }
  .custom_height_form_chat{
    border: none;
    width: 100%;
    padding: 9px 15px;
    background-color: #E2F2EF;
    border-radius: 6px;
      outline: none;
    
  }

  .bg-white{
    background-color: white;
   padding: 0 1rem 1.5rem 1rem;
  }
  .bg-custom{
    background-color: #E2F2EF;
  }
}
</style>